/**
 * The LLM endpoint aiTuter ships pinned to.
 *
 * Pinned rather than left to the settings UI so a student never has to type a
 * base URL or a key before their first lesson.
 *
 * SECURITY: `apiKey` ends up in the APK's JavaScript bundle. An APK is a zip and
 * this string is recoverable with `unzip` and `grep`, so treat the key as public
 * the moment a build leaves this machine. Rotate it rather than assume it is
 * secret, and keep the endpoint behind something that can revoke it.
 */
export const tutorLlmEndpoint = {
  // HTTP, not HTTPS: the host has no TLS listener on :24000, which is why
  // `capacitor.config.ts` serves the app from `http://localhost` — Android
  // WebView would otherwise block this as mixed content.
  //
  // This is the LLM endpoint only. `aitutor.mscbrain.co.kr` is a separate
  // service host and is deliberately not used here.
  baseUrl: 'http://dev.brainsp.com:24000/v1/',
  apiKey: 'iGOCjlMqZdTvhig5ktqA5eSeMZuTXlbmUQd9EIeHrNhKBDFCbaDj00uK9J2YKlir',
  model: 'gemma4:26b',
} as const

/** Provider id registered by `modules/tutor-llm-provider`. */
export const tutorLlmProviderId = 'aituter-llm'
